import type { TechConfig, TechCost, TechId } from '../types/technology.ts';

export const TECHNOLOGIES_CONFIG: Record<TechId, TechConfig> = {
  laser_tech: {
    id: 'laser_tech',
    name: 'Công Nghệ Tia Laser',
    category: 'military',
    description: 'Nâng cao hiệu suất chùm tia năng lượng cao, tăng sát thương laser.',
    max_level: 10,
    base_cost: { metal: 200, he3: 300, credits: 100 },
    cost_multiplier: 1.5,
    base_research_time_sec: 45,
    research_time_multiplier: 1.4,
    lab_level_required: 1,
  },
  ballistic_tech: {
    id: 'ballistic_tech',
    name: 'Động Năng Cao Cấp',
    category: 'military',
    description: 'Phát triển đầu đạn siêu thanh phá hủy giáp kiên cố.',
    max_level: 10,
    base_cost: { metal: 350, he3: 150, credits: 100 },
    cost_multiplier: 1.5,
    base_research_time_sec: 45,
    research_time_multiplier: 1.4,
    lab_level_required: 1,
  },
  missile_tech: {
    id: 'missile_tech',
    name: 'Hệ Thống Ngư Lôi & Tên Lửa',
    category: 'military',
    description: 'Định vị mục tiêu từ xa, cho phép tấn công xuyên thấu hàng trước.',
    max_level: 10,
    base_cost: { metal: 300, he3: 350, credits: 150 },
    cost_multiplier: 1.52,
    base_research_time_sec: 60,
    research_time_multiplier: 1.45,
    lab_level_required: 2,
  },
  shield_tech: {
    id: 'shield_tech',
    name: 'Màn Chắn Từ Trường',
    category: 'defense',
    description: 'Tăng lượng khiên bảo vệ và độ bền vững trước vũ khí năng lượng.',
    max_level: 10,
    base_cost: { metal: 150, he3: 400, credits: 120 },
    cost_multiplier: 1.5,
    base_research_time_sec: 50,
    research_time_multiplier: 1.4,
    lab_level_required: 1,
  },
  armor_tech: {
    id: 'armor_tech',
    name: 'Hợp Kim Nano Cường Lực',
    category: 'defense',
    description: 'Gia cố kết cấu thân tàu, tăng máu và chỉ số giảm trừ sát thương giáp.',
    max_level: 10,
    base_cost: { metal: 400, he3: 150, credits: 100 },
    cost_multiplier: 1.5,
    base_research_time_sec: 50,
    research_time_multiplier: 1.4,
    lab_level_required: 1,
  },
  engine_tech: {
    id: 'engine_tech',
    name: 'Động Cơ Đẩy Lực Ion',
    category: 'engineering',
    description: 'Tăng tốc độ di chuyển chiến thuật và sáng kiến xuất chiêu (Initiative).',
    max_level: 10,
    base_cost: { metal: 250, he3: 350, credits: 150 },
    cost_multiplier: 1.5,
    base_research_time_sec: 55,
    research_time_multiplier: 1.4,
    lab_level_required: 2,
  },
  mining_tech: {
    id: 'mining_tech',
    name: 'Tự Động Hóa Khai Thác',
    category: 'engineering',
    description: 'Tăng 10% sản lượng Kim loại và Heli-3 trên toàn hành tinh mỗi cấp.',
    max_level: 10,
    base_cost: { metal: 300, he3: 200, credits: 200 },
    cost_multiplier: 1.45,
    base_research_time_sec: 40,
    research_time_multiplier: 1.35,
    lab_level_required: 1,
  },
};

export function calculateTechUpgradeCost(id: TechId, currentLevel: number): TechCost {
  const cfg = TECHNOLOGIES_CONFIG[id];
  const mult = Math.pow(cfg.cost_multiplier, currentLevel);
  return {
    metal: Math.floor(cfg.base_cost.metal * mult),
    he3: Math.floor(cfg.base_cost.he3 * mult),
    credits: Math.floor(cfg.base_cost.credits * mult),
  };
}

export function calculateTechResearchTimeSec(id: TechId, currentLevel: number): number {
  const cfg = TECHNOLOGIES_CONFIG[id];
  const mult = Math.pow(cfg.research_time_multiplier, currentLevel);
  return Math.max(10, Math.floor(cfg.base_research_time_sec * mult));
}
